import { create } from 'zustand';

export type ToastType = 'success' | 'error' | 'warning' | 'info';

interface ToastState {
  message: string | null;
  type: ToastType;
  show: (message: string, type?: ToastType) => void;
  hide: () => void;
}

export const useToastStore = create<ToastState>()((set) => ({
  message: null,
  type: 'warning',
  show: (message, type = 'warning') => set({ message, type }),
  hide: () => set({ message: null, type: 'warning' }),
}));
